import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Sidebar from "./components/sidebar";
import Leads from "./components/Leads";
import QualifiedLeads from "./components/QualifiedLeads";
import Contacts from "./components/Contacts";
import Emails from "./components/Emails";
import Settings from "./components/Settings";
import LeadForm from "./components/LeadForm";
import AllEntriesForm from "./components/allEntriesForm";
import Home from "./components/Home";
import Deals from "./components/Deals";
import QuotationComponent from "./modals/QuoteLead";
import QuotationComponentAdmin from "./modals/QuoteLeadAdmin";
import { BreadcrumbsProvider } from "./modals/BreadcrumbsContext";
import Quotations from "./components/Quotations";
import QuotationPage from "./components/QuotationPage";
import StockList from "./components/StockList";
import LoginPage from "./components/LoginPage";
import QuotationsListViewFull from "./modals/QuotationsListViewFull";
import ConvertToSalesOrderScreen from "./modals/ConverToSalesOrderScreen";
import SalesOrderListViewFull from "./modals/SalesOrderListViewFull";
import SalesOrderDetailsUser from "./modals/SalesOrderDetailsUser";
import SalesOrderDetailsAdmin from "./modals/SalesOrderDetailsAdmin";
import SampleApprovalListViewFull from "./modals/SampleApprovalListViewFull";
import WorkOrderApprovalListViewFull from "./modals/WorkOrderApprovalListViewFull";
import ProtectedRouteMachine from "./components/ProtectedRouteMachine.js"
import ProtectedRouteLogin from "./components/ProtectedRouteLogin.js"
import MachineRegistration from "./components/MachineRegistration.js";
import JobsDashboard from "./taskManagement/JobsDashboard.js";

import NewJobForm from "./taskManagement/NewJobForm.js";
import "./css/App.css"

function AppContent() {


  const [rowsPerPage, setRowsPerPage] = useState("5");


  return (
    <div className="flex h-screen max-h-[100vh] overflow-y-auto scrollbar-thin">


      <div className="flex-1 flex flex-col h-screen ">



        <main className="flex-1 ml-16 pt-24 ps-5 main-content-div" style={{ backgroundColor: "#f8f8f8 " }}>
          <Routes>

            <Route path="/">

              <Route element={<ProtectedRouteMachine />}>

                {/* if machine registered can come inside else go to machine registration */}
                <Route path="" element={<LoginPage />} />

                <Route element={<ProtectedRouteLogin />}>
                  {/* All other routes that you want to protect will go inside here */}
                  <Route path="leads" element={<Leads />} />
                  <Route path="qualifiedLeadsTable" element={<QualifiedLeads />} />
                  <Route path="contacts" element={<Contacts />} />
                  <Route path="emails" element={<Emails />} />
                  <Route path="settings" element={<Settings rowsPerPage={rowsPerPage} setRowsPerPage={setRowsPerPage} />} />
                  <Route path="leadForm" element={<LeadForm />} />
                  <Route path="allEntriesForm" element={<AllEntriesForm />} />


                  <Route path="home" element={<Home />} />

                  
                  <Route path="deals" element={<Deals rowsPerPage={rowsPerPage} />} />
                  <Route path="quotations" element={<Quotations />} />
                  <Route path="quotationsListViewFull" element={<QuotationsListViewFull />} />
                  <Route path="salesOrderListViewFull" element={<SalesOrderListViewFull />} />
                  <Route path="sampleRequestListViewFull" element={<SampleApprovalListViewFull />} />
                  <Route path="workOrderListViewFull" element={<WorkOrderApprovalListViewFull />} />
                  <Route path="quotationPage" element={<QuotationPage />} />

                  <Route path="stockList" element={<StockList />} />
                  <Route path="quoteLead" element={<QuotationComponent />} />
                  <Route path="quoteLeadAdmin" element={<QuotationComponentAdmin />} />
                  <Route path="convert_to_sales_order" element={<ConvertToSalesOrderScreen />} />
                  <Route path="sales_order_details_user" element={<SalesOrderDetailsUser />} />
                  <Route path="sales_order_details_admin" element={<SalesOrderDetailsAdmin />} />

                  <Route path="jobs" element={<JobsDashboard />} />
                  <Route path="newJobForm" element={<NewJobForm />} />
                </Route>

              </Route>



              <Route path="machine_registration" element={<MachineRegistration />} />


            </Route>


          </Routes>
        </main>
      </div>
    </div>
  );
}

function App() {
  return (
    <BreadcrumbsProvider>
      <Router>
        <AppContent />
      </Router>
    </BreadcrumbsProvider>
  );
}

export default App;
